import {crearHash} from "../Funciones/crearHash";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {registrarMovimiento} from "../Movimientos/registrarMovimiento";
import {adap_compra_mov} from "../Adaptadores/adap_compra_mov";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";

export const realizarCompra = async ({usuario, desde, valor}) => {


    let doxConsecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})

    let compra = {
        nombre: usuario.nombre,
        codigo: usuario.codigo,
        correo: usuario.correo,
        valor: valor * -1,
        fecha: new Date().getTime(),
        idUsuario: usuario.id,
        consecutivo: doxConsecutivo.data,
    }

    compra.desde = desde
    compra.hashString = JSON.stringify(compra)
    compra.hash = crearHash({text: compra.hashString})
    compra.detalle = 'Activación de Membresia'
    compra.fechaRespuesta = new Date().getTime()

    let dox = await registrarMovimiento({
        movimiento: adap_compra_mov({usuario: usuario, compra: compra}),
        estado: 'Aceptado'
    })

    await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: compra.consecutivo})

    return dox

}
